import { atom } from "recoil";

type RiaBottomStateType = {
    currPathName: string;
}
export const RiaBottomState = atom<RiaBottomStateType>({
    key: "RiaBottomState",
    default: {
        currPathName: ""
    }
});

type BoardSearchListStateType = {
    currPage: number;
}
export const BoardSearchListState = atom<BoardSearchListStateType>({
    key: "BoardSearchListState",
    default: {
        currPage: 1
    }
});

export const DialogAlterState = atom<boolean>({
    key: "DialogAlterState",
    default: false
});

type DialogMessageStateType = {
    isShow: boolean;
    isConfirm: boolean;
    title: string;
    message: React.ReactNode;
    callbackFuncOk?: () => void;
    callbackFuncCancel?: () => void;
}
export const DialogMessageState = atom<DialogMessageStateType>({
    key: "DialogMessageState",
    default: {
        isShow: false,
        isConfirm: false,
        title: "",
        message: ""
    }
});

type ToastMessageStateType = {
    isShow: boolean;
    message: string;
}
export const ToastMessageState = atom<ToastMessageStateType>({
    key: "ToastMessageState",
    default: {
        isShow: false,
        message: ""
    }
});

export const CommunityBoardListState_BoardSeq = atom<string>({
    key: "CommunityBoardListState_BoardSeq",
    default: ""
});

export const CommunityBoardListState_SubMenu = atom<string>({
    key: "CommunityBoardListState_SubMenu",
    default: ""
});

type MoveButtonStateType = {
    isClickBtnOrder: boolean;
    isClickBtnRandom: boolean;
}
export const MoveButtonState = atom<MoveButtonStateType>({
    key: "MoveButtonState",
    default: {
        isClickBtnOrder: true,
        isClickBtnRandom: false
    }
});

export const BoardInfoState_CommentRegKey = atom<string>({
    key: "BoardInfoState_CommentRegKey",
    default: Math.random().toString()
});

export const IsBottomLoading = atom<boolean>({
    key: "IsBottomLoading",
    default: false
});

export const Ad_RefreshKey = atom<string>({
    key: "Ad_RefreshKey",
    default: ""
});

type ImgViewerType = {
    open: boolean;
    src: string;
    alt: string;
}
export const ImgViewer = atom<ImgViewerType>({
    key: "ImgViewer",
    default: {
        open: false,
        src: "",
        alt: ""
    }
});

export const IsShowReg = atom<boolean>({
    key: "IsShowReg",
    default: false
});

export const IsShowDetail = atom<boolean>({
    key: "IsShowDetail",
    default: false
});